import React, { useMemo } from 'react'
import { uniqueId } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Select, SelectItem } from '@ublique/components/Select'
import './index.scss'

const defaultOptions = [
  {
    id: 'option-1',
    text: '5',
    value: 5
  },
  {
    id: 'option-2',
    text: '10',
    value: 10
  },
  {
    id: 'option-3',
    text: '25',
    value: 25
  },
  {
    id: 'option-4',
    text: '50',
    value: 50
  },
  {
    id: 'option-5',
    text: '100',
    value: 100
  }
]

const getClosestOption = (size, options) =>
  options.reduce((acc, option) => (size <= acc.value ? acc : option))

const PaginationSizeChooser = ({
  initialValue,
  onChange,
  options = defaultOptions,
  size = 'xl'
}) => {
  const { t } = useTranslation('Document')

  const id = useMemo(() => uniqueId('pagination-size-'), [])

  const getPaginationList = () =>
    options.map((size, index) => (
      <SelectItem
        key={index}
        text={`${t('Rows')}: ${size.text}`}
        value={size.value}
      />
    ))

  return (
    <Select
      className='page-size-chooser'
      defaultValue={
        initialValue ? getClosestOption(initialValue, options).value : undefined
      }
      id={id}
      onChange={({ target }) => onChange(+target.value)}
      children={getPaginationList()}
      noLabel
      inline
      light
      size={size}
    />
  )
}

export default PaginationSizeChooser
